import { format, formatDistanceToNow, isValid } from 'date-fns'

/** Browser IANA timezone, detected once and reused. */
const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone

/** Intl-based formatters that always use the explicit browser timezone. */
const dateOnlyFmt = new Intl.DateTimeFormat(undefined, {
  timeZone: BROWSER_TZ,
  year: 'numeric', month: 'short', day: 'numeric',
})

const dateTimeFmt = new Intl.DateTimeFormat(undefined, {
  timeZone: BROWSER_TZ,
  year: 'numeric', month: 'short', day: 'numeric',
  hour: '2-digit', minute: '2-digit',
})

const dateTimeFullFmt = new Intl.DateTimeFormat(undefined, {
  timeZone: BROWSER_TZ,
  year: 'numeric', month: 'short', day: 'numeric',
  hour: '2-digit', minute: '2-digit', second: '2-digit',
})

const timeOnlyFmt = new Intl.DateTimeFormat(undefined, {
  timeZone: BROWSER_TZ,
  hour: '2-digit', minute: '2-digit', second: '2-digit',
})

function toDate(value: unknown): Date | null {
  if (value == null) return null
  const d = value instanceof Date ? value : new Date(value as string)
  return isValid(d) ? d : null
}

export function fmtDate(value: unknown): string {
  const d = toDate(value)
  return d ? dateOnlyFmt.format(d) : '--'
}

export function fmtDateTime(value: unknown): string {
  const d = toDate(value)
  return d ? dateTimeFmt.format(d) : '--'
}

export function fmtDateTimeFull(value: unknown): string {
  const d = toDate(value)
  return d ? dateTimeFullFmt.format(d) : '--'
}

export function fmtTime(value: unknown): string {
  const d = toDate(value)
  return d ? timeOnlyFmt.format(d) : '--'
}

export function fmtRelative(value: unknown): string {
  if (value == null) return '--'
  const d = new Date(value as string)
  if (!isValid(d)) return '--'
  return formatDistanceToNow(d, { addSuffix: true })
}

/** date-fns format() with explicit note: uses JS runtime timezone (same as browser). */
export function fmtPattern(value: unknown, pattern: string): string {
  const d = toDate(value)
  return d ? format(d, pattern) : '--'
}
